'use client'

import Link from 'next/link'
import { SignedIn, SignedOut } from '@/lib/auth/context'
import { CheckoutButton } from '@/components/billing/checkout-button'
import { PremiumLink } from '@/components/analytics/tracked-link'
import { PLANS } from '@/lib/billing/plans'
import type { PremiumCtaLocal } from '@/lib/analytics'

/**
 * CTA de assinatura (island) — visitante anônimo vai pro cadastro; logado vai
 * pro checkout Mercado Pago. Reusa o wiring de billing existente.
 */
export function PremiumCta({
  local,
  secundario,
}: {
  local: PremiumCtaLocal
  /** Botão secundário opcional (texto + href). */
  secundario?: { label: string; href: string }
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
      <SignedOut>
        <PremiumLink
          href="/sign-up?next=/premium"
          local={local}
          className="inline-flex h-12 items-center justify-center bg-brand px-7 text-[15px] font-medium text-white hover:bg-brand-dark"
        >
          Assinar o Premium · {PLANS.PREMIUM.priceDisplay}/mês
        </PremiumLink>
        {secundario && (
          <Link
            href={secundario.href}
            className="inline-flex h-12 items-center justify-center border border-line bg-surface px-7 text-[15px] font-medium text-ink hover:border-brand hover:bg-brand-tint"
          >
            {secundario.label}
          </Link>
        )}
      </SignedOut>
      <SignedIn>
        <CheckoutButton size="lg" trackingLocal={local}>
          Assinar o Premium · {PLANS.PREMIUM.priceDisplay}/mês
        </CheckoutButton>
        {secundario && (
          <Link
            href={secundario.href}
            className="inline-flex h-12 items-center justify-center border border-line bg-surface px-7 text-[15px] font-medium text-ink hover:border-brand hover:bg-brand-tint"
          >
            {secundario.label}
          </Link>
        )}
      </SignedIn>
    </div>
  )
}
